import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
  Slider,
} from "@shortsworks/ui";
import { FormItemProps } from "@app/components/forms/types/props";
import { cn } from "@shortsworks/ui/lib/utils";
import { RangeInputSchema } from "@app/components/forms/types/schema";

export const FormRange = ({
  form,
  schema,
  ...rest
}: FormItemProps<RangeInputSchema>) => {
  const handleValueChange = (value: number[]) => {
    form.setValue(schema.id, value[0]);
  };

  return (
    <FormField
      control={form.control}
      name={schema.id}
      render={({ field }: any) => {
        return (
          <FormItem
            className={cn(
              schema.appearance?.className,
              schema.appearance?.border
                ? "border p-3 rounded-lg shadow-sm"
                : "",
              schema.behavior?.hidden && "hidden",
              "space-y-2.5",
            )}
          >
            <FormLabel className="flex items-center justify-between pt-0.5 pr-0.5">
              {typeof schema.label === "function"
                ? schema.label(form.getValues())
                : schema.label}
              <Input
                min={schema.min || 0}
                max={schema.max || 100}
                step={schema.step || 1}
                className="w-20 h-8"
                type="number"
                placeholder={schema.placeholder}
                {...field}
                {...schema.behavior}
                value={[field.value || 0]}
              />
            </FormLabel>
            <FormControl
              style={{ flexOrder: schema.layout === "horizontal" ? 1 : 2 }}
            >
              <Slider
                min={schema.min || 0}
                max={schema.max || 100}
                step={schema.step || 1}
                {...field}
                {...schema.behavior}
                value={[field.value || 0]}
                onValueChange={handleValueChange}
              />
            </FormControl>
            {schema.description && (
              <FormDescription
                style={{ flexOrder: schema.layout === "horizontal" ? 2 : 1 }}
              >
                {typeof schema.description === "function"
                  ? schema.description(form.getValues())
                  : schema.description}
              </FormDescription>
            )}
            <FormMessage />
          </FormItem>
        );
      }}
    />
  );
};
